module.exports = "/fonts/vendor/quasar-extras/material-icons/web-flUhRq6tzZclQEJ-Vdg-IuiaDsNa.woff?c38ebd3cd38c98fbd16bf31d1d24ce64";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/material-icons/web-font/flUhRq6tzZclQEJ-Vdg-IuiaDsNa.woff
// module id = 8Ivd
// module chunks = 0